var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "filterModal",
        size: "lg",
        title: `Filter: ${_vm.filter_layer}`,
        "content-class": "menu-bg-blue-transparent-modal filter-modal-content",
        "header-class": "filter-modal-header",
        "body-class": "filter-modal-body",
        "hide-footer": "",
      },
      on: { hidden: _vm.closed },
    },
    [
      _vm.globalIsUserAllowed("Layer_Filter_Export_Shapefile") ||
      (_vm.isErrorsLayer && _vm.globalIsUserAllowed("Layer_Filter_Export_CSV"))
        ? _c(
            "div",
            { staticClass: "filter-export-bar" },
            [
              _vm.isErrorsLayer &&
              _vm.globalIsUserAllowed("Layer_Filter_Export_CSV")
                ? _c(
                    "b-button",
                    {
                      staticClass: "filter-btn",
                      attrs: { variant: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.exportFilterFile("csv")
                        },
                      },
                    },
                    [
                      _c("fa", {
                        staticClass: "mr-1",
                        attrs: { icon: ["fas", "download"] },
                      }),
                      _vm._v(" Export CSV\n    "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Layer_Filter_Export_Shapefile")
                ? _c(
                    "b-button",
                    {
                      staticClass: "filter-btn",
                      attrs: { variant: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.exportFilterFile("shape")
                        },
                      },
                    },
                    [
                      _c("fa", {
                        staticClass: "mr-1",
                        attrs: { icon: ["fas", "download"] },
                      }),
                      _vm._v(" Export Shapefile\n    "),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-builder" },
        [
          _c("span", { staticClass: "filter-builder-title" }, [
            _vm._v("Add a filter rule"),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "align-items-end no-gutters" },
            [
              _c(
                "b-col",
                { staticClass: "col-sm-4 pr-2" },
                [
                  _c("label", { staticClass: "filter-field-label" }, [
                    _vm._v("Property"),
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: {
                      list: "property_list",
                      name: "properties",
                      id: "properties",
                      placeholder: "Property",
                    },
                    model: {
                      value: _vm.filter_property,
                      callback: function ($$v) {
                        _vm.filter_property = $$v
                      },
                      expression: "filter_property",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-datalist",
                    { attrs: { id: "property_list" } },
                    [
                      _c("option", { attrs: { value: "" } }),
                      _vm._v(" "),
                      _vm._l(_vm.layerProperties, function (prop, i) {
                        return _c(
                          "b-form-select-option",
                          { key: i, attrs: { value: prop.name } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(prop.name) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-2 pr-2" },
                [
                  _c("label", { staticClass: "filter-field-label" }, [
                    _vm._v("Operator"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      attrs: { id: "operatorSelect" },
                      on: { change: _vm.checkOperator },
                      scopedSlots: _vm._u([
                        {
                          key: "first",
                          fn: function () {
                            return [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null, disabled: "" } },
                                [
                                  _vm._v(
                                    "\n              Operator\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.filter_operator,
                        callback: function ($$v) {
                          _vm.filter_operator = $$v
                        },
                        expression: "filter_operator",
                      },
                    },
                    [
                      _vm._v(" "),
                      _vm._l(_vm.operators, function (op) {
                        return _c(
                          "b-form-select-option",
                          { key: op.id, attrs: { value: op.tag } },
                          [
                            _vm._v(
                              "\n            " + _vm._s(op.tag) + "\n          "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-2 pr-2" },
                [
                  _c("label", { staticClass: "filter-field-label" }, [
                    _vm._v("Value"),
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { placeholder: "Value" },
                    model: {
                      value: _vm.filter_value,
                      callback: function ($$v) {
                        _vm.filter_value = $$v
                      },
                      expression: "filter_value",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-2 pr-2 filter_value_2" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "filter-field-label",
                      class: { invisible: _vm.isHidden },
                    },
                    [_vm._v("Value 2")]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: {
                      placeholder: "Value",
                      hidden: _vm.isHidden,
                      name: "filter_value_2",
                    },
                    model: {
                      value: _vm.filter_value_2,
                      callback: function ($$v) {
                        _vm.filter_value_2 = $$v
                      },
                      expression: "filter_value_2",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-2" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "filter-btn filter-add-btn w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.addRule()
                        },
                      },
                    },
                    [
                      _c("fa", {
                        staticClass: "mr-1",
                        attrs: { icon: ["fas", "plus"] },
                      }),
                      _vm._v(" Add Rule\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.rules.filter((r) => r.layer == _vm.filter_layer).length
        ? _c("div", { staticClass: "active-rules" }, [
            _c("span", { staticClass: "active-rules-title" }, [
              _vm._v("Active rules"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rule-chips" },
              _vm._l(
                _vm.rules.filter((r) => r.layer == _vm.filter_layer),
                function (rule, i) {
                  return _c("span", { key: i, staticClass: "rule-chip" }, [
                    _c("span", { staticClass: "rule-chip-prop" }, [
                      _vm._v(_vm._s(rule.property)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "rule-chip-op" }, [
                      _vm._v(_vm._s(rule.operator)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "rule-chip-val" },
                      [
                        _vm._v("\n          " + _vm._s(rule.value)),
                        rule.value2 != null
                          ? [_vm._v(" – " + _vm._s(rule.value2))]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                }
              ),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-options" },
        [
          _c(
            "p",
            { staticClass: "filter-hint" },
            [
              _c("fa", {
                staticClass: "mr-1",
                attrs: { icon: ["fas", "info-circle"] },
              }),
              _vm._v("\n      If "),
              _c("strong", [_vm._v("Maintain View")]),
              _vm._v(
                " is unchecked, the map zooms to bound all\n      features. This can significantly impact performance when filtering dense\n      layers with loose filters.\n      "
              ),
              _vm.filter_layer == "errors" || _vm.filter_layer == "errors_test"
                ? [
                    _c("br"),
                    _vm._v(
                      "\n        Error status and severity can be searched by exact value\n        (e.g. status = active, severity = high).\n      "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "filter-maintain-view",
              model: {
                value: _vm.maintainView,
                callback: function ($$v) {
                  _vm.maintainView = $$v
                },
                expression: "maintainView",
              },
            },
            [_vm._v("\n      Maintain View\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-footer" },
        [
          _c(
            "b-button",
            {
              staticClass: "filter-btn",
              attrs: { variant: "outline-danger" },
              on: { click: _vm.removeFilter },
            },
            [_vm._v("\n      Remove Filter\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "filter-btn filter-apply-btn",
              attrs: { variant: "success" },
              on: {
                click: function ($event) {
                  return _vm.generateCQL(null, true)
                },
              },
            },
            [_vm._v("\n      Apply Filter\n    ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }